<template>
      
    <el-container>
          <!-- 头部 -->
        <div class="indeherader">
           <el-header class="flex nsherader">  
               <MangeHeader />
           </el-header>
        </div>
        <!-- 菜单 -->
           <div class="sidebar">
             <MangeSidebar />
        </div>
        <el-main class="indemain">
            <transition name="slide">
              <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view> 
          </keep-alive>
            </transition>
            <router-view v-if="!$route.meta.keepAlive"></router-view>

        </el-main>
         <!-- 底部 -->
        <div class="indefooter">
             <el-footer><ns-footer /></el-footer>
        </div>
    </el-container>
</template>
<script>
    import { getCurrentUser} from "@/api/enterprise/index"; // 获取当前企业信息
    import MangeHeader from "./components/MangeHeader"
    import NsFooter from "./components/NsFooter"
    import MangeSidebar from "./components/MangeSidebar"
    export default {
        name: "Layout",
       inject: ["reload"],
        components: {
            MangeHeader,
             NsFooter,
             MangeSidebar
        },
        data () {
          return {
            businessInfo:{},
          }
        },
        created() {
           this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
           this.getUserInfo()
           this.$bus.$off('thisGetinfo')
            this.$bus.$on("thisGetinfo", msg =>{ 
              if(msg){
                this.getUserInfo()
              }
          })
        },
        mounted() {},
        computed: {
        },

        watch: {},
        methods: {
          // 获取当前用户信息
        getUserInfo(){
             getCurrentUser({
                id:this.businessInfo.id
              },'enterprise')
            .then(res => {
            localStorage.removeItem('currentUserInfo')
            this.$locaStorage.setAge().set('currentUserInfo',res.data.user_info)
            })
        },
        },
        destroyed(){
          this.$bus.$off('thisGetinfo')
        }
    }
</script>
<style lang="scss" scoped>
.el-left{
  display: flex;
}
.el-right{
  width: 100%;
  margin-left: 17%;;
}
.menu-left{
  background: #304156;
  position: fixed;
  left: 0;
  height: 100%;
}
.indeherader{
    height: 56px;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #fff;
    border-bottom: 1px solid rgb(235, 237, 240);
    width: 100%;
    .nsherader{
        width: 100%;
        margin: 0 auto;
        height: inherit !important;
    }
}
.navbar{
    width: calc(100% - 200px);
    height: 20px;
    position: fixed;
    left: 200px;
    top: 80px;
    padding: 20px;
}
.sidebar{
    width: 200px;
    background: #fff;
    height: calc(100vh - 57px);
    position: fixed;
    left: 0;
    top: 58px;
    border-right: 1px solid #edeef2;
    box-sizing: border-box;
}

.hideSidebar{
   .sidebar{
    width: 54px;
   } 
   .indefooter,.indemain,.navbar{
     width: calc(100% - 54px);
     left: 54px;
   }
}
.indefooter{
  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.08);
    background: #FFF;
    height: 60px;
    position: fixed;
    left: 200px;
    bottom: 0px;
    width: calc(100% - 200px);
}
.indemain{
    width: calc(100% - 200px);
    height: calc(100vh - 120px);
    position: fixed;
    left: 200px;
    top: 57px;
    overflow: auto;
    background: rgb(245, 246, 250);
}
::v-deep{
    .sidebar{
        .el-menu{background: none !important;border: none !important;}
.el-submenu,.el-menu-item,.el-submenu__title,.el-menu-item [class^=el-icon-],.el-submenu [class^=el-icon-] {
  color: #fff;
}
.el-submenu__title i {
    color: #fff;
    padding-right: 20px;
}
.el-menu-item:hover,.el-submenu__title:hover{
    outline: 0;
    background-color: #263445 !important;

}
.el-menu-item:focus,.el-submenu__title:focus{
    outline: 0;
    background-color: #263445 !important;

}
    }
.hideSidebar .el-right{
  margin-left: 54px !important;
}
}
</style>
